import { formatPhoneNumber } from '../../helpers/format-phone-number';
import { getDefaultCountryCode } from '../../helpers/default-country-code';
import { SUGAR_CRM_FIELDS } from '../core/field-contract';
import { StandardFormSession } from './StandardFormSession';
import { FreeTrialSession } from './FreeTrialSession';
export class FormHandler {
    fields = SUGAR_CRM_FIELDS;
    createForm(formName, options = {}) {
        return new StandardFormSession(formName, options);
    }
    createFreeTrial(options) {
        return new FreeTrialSession(options);
    }
    async toE164(number, country) {
        const iso2 = (country || getDefaultCountryCode() || undefined)?.toLowerCase();
        try {
            const utils = (await import('intl-tel-input/utils')).default;
            if (!utils.isValidNumber(number, iso2)) {
                return null;
            }
            return utils.formatNumber(number, iso2, 'E164') || null;
        }
        catch (e) {
            return formatPhoneNumber(number) || null;
        }
    }
}
